export default __webpack_public_path__ + "static/media/file.68e1c324.svg";